// extracted by mini-css-extract-plugin
export var errorIcon = "_o4-1";
export var nameLogo = "_o4-0";